import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { ITutorSorting } from '.';

export type TAdminGetTutorSorting = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  curriculum?: string;
  subject?: string;
  grade?: string;
};

export type TAdminUpdateTutorSorting = {
  _id: string;
  manualSorting?: Array<{
    tutor: string;
    sortingKey: number;
  }>;
  badges?: Array<{
    tutor: string;
    badge: string;
    color: string;
  }>;
};

const apiDataProvider = new APIDataProvider();

const adminGetTutorSortingModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  curriculum,
  subject,
  grade,
}: TAdminGetTutorSorting) => {
  let path = `${AdminApiPaths.tutorSorting}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (curriculum) {
    path += `&curriculum=${curriculum}`;
  }

  if (subject) {
    path += `&subject=${subject}`;
  }

  if (grade) {
    path += `&grade=${grade}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ITutorSorting>>
  >(path);

  return response.data;
};

export const adminGetTutorSorting = createAsyncThunk(
  '/admin/tutor-sortings/list',
  adminGetTutorSortingModule
);

export const adminUpdateTutorSorting = createAsyncThunk(
  '/admin/tutor-sortings/update',
  async (data: TAdminUpdateTutorSorting) => {
    const path = `${AdminApiPaths.tutorSorting}`;

    const response = await apiDataProvider.put<TApiResponse<ITutorSorting>>(
      path,
      data
    );

    return response.data;
  }
);
